import { Box, Button } from '@palmetto/palmetto-components';

import { AccountDocument, incentiveStatusLabels, IncentiveTypeLabels } from 'types';

import DateTimeDisplay from '../../DateTime';

export const getIncentiveAllocationProperties = (
  account: AccountDocument,
  openIncentivesHistoryModal: () => void,
) => {
  const allocations = account.incentiveAllocations?.currentAssignments || [];
  const allocationProperties: { label: string; value: any }[] = [];
  const hasMultipleAllocations = allocations.length > 1;
  for (const allocation of allocations) {
    allocationProperties.push(
      { label: 'Allocation Name', value: allocation?.allocationName || '---' },
      {
        label: 'Effective Date',
        value: <DateTimeDisplay value={allocation?.dateAssigned?.toString()} dateFormat={'DD'} excludeTime />,
      },
      {
        label: 'Incentive Type',
        value: allocation?.incentiveType ? IncentiveTypeLabels[allocation.incentiveType] : '---',
      },
      { label: 'Status', value: allocation?.status ? incentiveStatusLabels[allocation.status] : '---' },
    );
    if (allocation?.blockReason) {
      allocationProperties.push({ label: 'Block Reason', value: allocation.blockReason });
    }
    if (allocation?.blockDate) {
      allocationProperties.push({
        label: 'Block Date',
        value: <DateTimeDisplay value={allocation.blockDate.toString()} dateFormat={'DD'} excludeTime />,
      });
    }
    if (hasMultipleAllocations) {
      allocationProperties.push({ label: '', value: <Box margin="md 0 0 0" /> });
    }
  }
  if (account?.incentiveAllocations?.history?.length) {
    allocationProperties.push({
      label: 'Incentive History',
      value: (
        <Button variant="primary" tone="neutral" size="xs" onClick={openIncentivesHistoryModal}>
          View History ({account?.incentiveAllocations?.history?.length || 0})
        </Button>
      ),
    });
  }

  return allocationProperties;
};
